import * as React from "react";
import { SetStateAction, Dispatch } from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrInputMoney } from 'src/components/common/PbrInputMoney/PbrInputMoney';
import { IPricingCalculatorRequest } from "src/services/interfaces/calculator/IPricingCalculatorRequest";
import { IPricingParametersCalculator } from "src/services/interfaces/calculator/IPricingParametersCalculator";


interface IPriceSpreadComponent {
  label: string;
  request: IPricingCalculatorRequest;
  onChangePriceRequest: Dispatch<SetStateAction<Partial<IPricingCalculatorRequest>>>;
  onChangePriceParametersRequest: Dispatch<SetStateAction<Partial<IPricingParametersCalculator>>>;
}

export function PriceSpreadComponent(props: IPriceSpreadComponent & FormComponentProps) {

  return (
    <>
      <PbrInputMoney
        placeholder="R$ 0.00"
        name="price"
        value={props.request?.price}
        formItemProps={{ label: "Preço" }}
        formWrapper={props.form}
        rules={[{ required: true, message: "O preço é obrigatório" }]}
        onChange={e => props.onChangePriceRequest({ price: Number(e), spread: 0 })} // handlePriceRequest
      />
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/PricingComponents/PriceSpreadComponent/PriceSpreadComponent.tsx